import React, {FC} from "react"
import {Wallet} from "@irati/types"
import {Row, Col} from "react-bootstrap"

import {FormattedMessage} from "@irati/utils/lang"
import Spacing from "@irati/ui/src/Spacing"
import Transactions from "../AdminReward/Transactions"
import {DesktopHeader} from "./styled"

interface Props {
  wallet: Wallet
}

const RewardPoints: FC<Props> = ({wallet}) => {
  if (!Object.keys(wallet).length) {
    return null
  }

  return (
    <Row>
      <Col md={12}>
        <Spacing marginTop={4}>
          <DesktopHeader marginBottom={2}>
            <FormattedMessage id="wallet.transactions.title.rewardPoints" />
          </DesktopHeader>
          <Transactions walletId={wallet.uuid} />
        </Spacing>
      </Col>
    </Row>
  )
}

export default RewardPoints
